document.addEventListener('DOMContentLoaded', function() {
    var descriptionText = document.getElementById('description-text');
  
    if (!descriptionText) {
      return; 
    }
  
    var readMore = document.getElementById('read-more');
    var readLess = document.getElementById('read-less');
  
    readMore.addEventListener('click', function(event) {
      event.preventDefault();
      descriptionText.classList.add('full-text');
      readMore.classList.add('active');
      readLess.classList.add('active');
    });
  
    readLess.addEventListener('click', function(event) {
      event.preventDefault();
      descriptionText.classList.remove('full-text');
      readMore.classList.remove('active');
      readLess.classList.remove('active');
    });
  });
  